'use client';

import {
	Badge,
	Card, Flex, HStack, Stack,
	useSlotRecipe,
} from '@chakra-ui/react';
import { MdCalendarToday } from 'react-icons/md';

import { IconLabel } from '@/modules/shared/presentation';

import { useJobDetailContext } from './JobDetail';

export const JobDetailHeader = () => {
	const { job } = useJobDetailContext();
	const recipe = useSlotRecipe({ key: 'jobCard' });
	const styles = recipe();

	const jobStateDate = job.startDate?.toLocaleDateString();
	const jobEndDate = job.expiredDate ? ` - ${job.expiredDate.toLocaleDateString()}` : '';
	const jobDate = `${jobStateDate}${jobEndDate}`;

	return (
		<Card.Root>
			<Card.Header css={styles.header}>
				<Stack gap={0}>
					<Card.Title css={styles.title}>
						{job.company.name}
					</Card.Title>
					<Card.Description css={styles.description}>
						{job.title}
					</Card.Description>
				</Stack>
				<HStack justifyContent="space-between">
					<Flex gap={3}>
						<Badge>New</Badge>
						<Badge variant="outline">Plain</Badge>
					</Flex>
					<IconLabel icon={MdCalendarToday} label={jobDate} variant="caption" />
				</HStack>
			</Card.Header>
		</Card.Root>
	);
};
